import { render, staticRenderFns } from "./internalExternalIssues.vue?vue&type=template&id=7c2aae3c"
import script from "./internalExternalIssues.vue?vue&type=script&lang=js"
export * from "./internalExternalIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2aae3c')) {
      api.createRecord('7c2aae3c', component.options)
    } else {
      api.reload('7c2aae3c', component.options)
    }
    module.hot.accept("./internalExternalIssues.vue?vue&type=template&id=7c2aae3c", function () {
      api.rerender('7c2aae3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iei/internalExternalIssues.vue"
export default component.exports